import { code } from "@spscommerce/utils";

export const SpsSplitButtonExamples = {
    kinds: {
        label: "Regular Split Buttons",
        description: code`<p>info about split buttons</p>`,
        examples: {
            basic: {
                description: code`<p>Basic</p>`,
                template: code`
                    <sps-split-button id="basic" label="Default Button" class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-split-button>
                    <sps-split-button kind="confirm" label="Confirm Button" class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-split-button>
                    <sps-split-button kind="key" label="Key Button" class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-split-button>
                    <sps-split-button kind="delete" label="Delete Button" class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-split-button>
                `
            }
        }
    },
    withIcons: {
        label: "Split Buttons with Icons",
        description: code`<p>info about icon split buttons</p>`,
        examples: {
            withIcons: {
                description: code`<p>With Icons</p>`,
                template: code`
                    <sps-split-button id="withIcon" icon="drill" label="Default Button" class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-split-button>
                    <sps-split-button icon="rocket" kind="confirm" label="Confirm Button" class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-split-button>
                    <sps-split-button icon="key" kind="key" label="Key Button" class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-split-button>
                    <sps-split-button icon="trash" kind="delete" (clicked)="alert()" label="Delete Button" class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-split-button>
                `,
                class: code`
                    class DemoComponent {
                        alert() {
                            window.alert("Button clicked");
                        }
                    }
                `
            }
        }
    },
    disabled: {
        label: "Disabled Split Buttons",
        description: code`<p>info about disabled split buttons</p>`,
        examples: {
            disabled: {
                description: code`<p>Disabled</p>`,
                template: code`
                    <sps-split-button disabled id="disabled" kind="key" label="Disabled Button" class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-split-button>
                    <sps-split-button disabled kind="key" icon="drill" label="Disabled Button" class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-split-button>
                `
            }
        }
    }
};
